import React from 'react';
import { School } from 'models/school';
import TournamentDirectory from '../TournamentDirectory/TournamentDirectory';

export default function UpcomingTournaments({ school }: { school: School }) {
   return <TournamentDirectory school={school} mode='upcoming' />;
}
